const getDistanceLabel = (distance) =>
  distance > 1000 ? `${Math.floor(distance / 1000)}km` : `${distance}m`;

export { getDistanceLabel };
